import React from 'react';
import { Link } from 'react-scroll'; // Import Link from react-scroll
import '../styles/headerStyles.css';
import logo from '../assets/Logos/goal-logo-color-1-rgb.png';

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        {/* Logo Section */}
        <div className="logo-wrapper">
          <a href="" className="logo">
            <img src={logo} alt="GoalTV Logo" className="logo-image" />
          </a>
        </div>
        <div className="nav">
          <Link to="intro-section" smooth={true} duration={500} className="nav-item">SUBSCRIBE</Link>
          <Link to="programing-section" smooth={true} duration={500} className="nav-item">CONTENT</Link>
          <Link to="newsletter-section" smooth={true} duration={500} className="nav-item">NEWSLETTER</Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
